/**
 * @desc 获取当前流程的处理记录
 */
const URL = "/rantion-activiti";
import http, { updateResponse } from "@/http";
export type Response = defs.activiti.ResponseDto<Array<defs.activiti.BpmActivitiOpinionDto>>;
export function request(
  params: API.activiti.activiti.getInstanceFlowOpinions.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/activitiFacade/getInstanceFlowOpinions`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
